module.exports = __webpack_public_path__ + "img/assest.55c2a019.svg";